import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class FullScreenLoadingService {
  private readonly _isLoading$ = new BehaviorSubject<boolean>(false);

  show() {
    setTimeout(() => this._isLoading$.next(true));
  }

  hide() {
    setTimeout(() => this._isLoading$.next(false));
  }

  get isLoading$() {
    return this._isLoading$.asObservable();
  }
}
